import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = "https://lrwjahmdpflelhargtet.supabase.co"
const SUPABASE_ANON_KEY = "sb_publishable_6ZAnXdmA-gmWOMjJkOZfOg_aDE_WmkZ"

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)